namespace advisorop.components.servicer {

    class SelectCuAdvisorServicerController {
        onAdvisorSelected: any;
        selectedAdvisor: domains.IAdvisor;
        advisor: domains.IAdvisor;
        isAdvisorFormVisible: boolean = false;
        label: string;
        labelColWidth: number = 2;
        clearAfterSelect: string = "true";
        //noResults: boolean;
        advisorFirm: number;
        companyGroupId: number;


        static $inject = ["advisorService", "servicerService"];
        constructor(public advisorService: services.AdvisorService, private servicerService: services.ServicerService) {
        }

        $onInit(): void {
            //this.noResults = true;
            this.isAdvisorFormVisible = false;
        };

        $routerOnActivate(next, previous) {
        };

        search(searchTerm: string): ng.IPromise<{}> {
            return this.servicerService.searchAdvisors(searchTerm, this.companyGroupId).then((response) => {
                return response.data;
            });
        };

        onSelect(item, model, label, event): void {
            var adv: domains.IAdvisor = {};
            angular.copy(this.selectedAdvisor, adv);
            //clear only if clear property is set
            if (this.clearAfterSelect === "true")
                this.resetSearch();
            this.onAdvisorSelected({ advisor: adv });    
        };
        
        resetSearch(): void {
            this.selectedAdvisor = null;
            this.advisor = null;
            this.isAdvisorFormVisible = false;
            //this.noResults = true;
        };

        advisorCreated(advisor: domains.IAdvisor): void {
            var adv: domains.IAdvisor = {};
            angular.copy(advisor, adv);
            this.resetSearch();
            this.onAdvisorSelected({ advisor: adv });                      
        };


        $onChanges(evt): void {
            for (var key in evt) {
                if (key === "companyGroupId") {
                    if (this.companyGroupId > 0)
                        this.companyGroupId = this.companyGroupId;
                }
               
            }
        }

    }



    class SelectCuAdvisorServicer implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;

        constructor() {
            this.bindings = {
                onAdvisorSelected: "&",
                selectedAdvisor: "=",
                advisor: "@",
                label: "@",
                labelColWidth: "@",
                clearAfterSelect: "@",
                advisorFirm: "<",
                companyGroupId: "<"
            };
            this.controller = SelectCuAdvisorServicerController;
            this.controllerAs = "vm";
            this.templateUrl = 'spa/servicer-module/components/select-cu-advisor-servicer.html';
        }
    }
    angular.module(Constants.APP).component("selectCuAdvisorServicer", new SelectCuAdvisorServicer());


}